import { useState, useEffect } from "react";
import api from "@/lib/api";
import { Eye, Image as ImageIcon, Film, Loader2, X } from "lucide-react";

function useMediaBlob(path, enabled) {
  const [url, setUrl] = useState("");
  const [error, setError] = useState(false);
  useEffect(() => {
    if (!enabled || !path) return;
    let objUrl = "";
    api.get(`/chat-media/${path}`, { responseType: "blob" })
      .then(({ data }) => { objUrl = URL.createObjectURL(data); setUrl(objUrl); })
      .catch(() => setError(true));
    return () => { if (objUrl) URL.revokeObjectURL(objUrl); };
  }, [path, enabled]);
  return { url, error };
}

export default function ChatMedia({ media, mine, testid, onLoad }) {
  const [revealed, setRevealed] = useState(!!mine);
  const [zoom, setZoom] = useState(false);
  const { url, error } = useMediaBlob(media.path, revealed);
  const isVideo = media.type === "video";

  if (!revealed) {
    return (
      <button data-testid={`${testid}-reveal`} onClick={() => setRevealed(true)}
        className="relative flex h-44 w-56 max-w-full flex-col items-center justify-center gap-2 overflow-hidden rounded-xl border border-zinc-700 bg-gradient-to-br from-rose-950 via-zinc-900 to-zinc-950 text-zinc-300 transition-colors hover:border-rose-600">
        <div className="absolute inset-0 backdrop-blur-xl" />
        {isVideo ? <Film className="relative h-7 w-7 text-rose-300" /> : <ImageIcon className="relative h-7 w-7 text-rose-300" />}
        <span className="relative flex items-center gap-1.5 text-xs font-medium"><Eye className="h-3.5 w-3.5" /> Tik om {isVideo ? "video" : "foto"} te bekijken</span>
      </button>
    );
  }
  if (error) return <div data-testid={`${testid}-error`} className="rounded-xl border border-zinc-700 px-4 py-3 text-xs text-zinc-400">Kon bestand niet laden</div>;
  if (!url) return <div className="flex h-44 w-56 max-w-full items-center justify-center rounded-xl bg-zinc-900"><Loader2 className="h-6 w-6 animate-spin text-rose-400" /></div>;

  return (
    <>
      {isVideo ? (
        <video data-testid={`${testid}-video`} src={url} controls playsInline onLoadedMetadata={onLoad} className="max-h-80 w-72 max-w-full rounded-xl bg-black" />
      ) : (
        <button onClick={() => setZoom(true)} className="block">
          <img data-testid={`${testid}-image`} src={url} alt="" onLoad={onLoad} className="max-h-80 w-auto max-w-full rounded-xl object-cover ring-1 ring-black/30" />
        </button>
      )}
      {zoom && (
        <div data-testid={`${testid}-lightbox`} className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4" onClick={() => setZoom(false)}>
          <button className="absolute top-4 right-4 text-white"><X className="h-6 w-6" /></button>
          <img src={url} alt="" className="max-h-full max-w-full rounded-lg" />
        </div>
      )}
    </>
  );
}
